!function () {
  "use strict";

  const SELECTOR_SCROLL_TO = "[data-scroll-to]";
  const SELECTOR_TOOLTIP = "[data-tooltip]";
  const SELECTOR_COLLAPSIBLE_TRIGGER = "[data-collapsible-trigger]";
  const ATTR_OPEN = "open";
  const ATTR_SCROLL_TO = "data-scroll-to";
  const ATTR_TOOLTIP_STOP = "data-tooltip-stop-mouseenter";

  class ScrollToElement extends HTMLElement {
    constructor() {
      super();
      this.scrollToButton = this.querySelector(SELECTOR_SCROLL_TO);
    }

    connectedCallback() {
      if (!this.scrollToButton) return;

      this.scrollToButton.addEventListener("click", () => {
        const target = document.querySelector(
          this.scrollToButton.getAttribute(ATTR_SCROLL_TO)
        );

        if (target && this.scrollToButton.tagName !== "A") {
          this.scrollToElement(target);
        }
      });
    }

    scrollToElement(target) {
      // scrollTo = méthode existante dans window.theme
      window.theme.scrollTo(target.getBoundingClientRect().top + 1);

      // Gestion auto-open d’un <details>
      const pane = target.nextElementSibling?.matches?.("details")
        ? target.nextElementSibling
        : null;

      if (pane) {
        const trigger = pane.querySelector(SELECTOR_COLLAPSIBLE_TRIGGER);
        const wantsAutoOpen = pane.hasAttribute("data-auto-open");

        if (!pane.hasAttribute(ATTR_OPEN) && wantsAutoOpen) {
          trigger?.dispatchEvent(new Event("click"));
        }
      }

      // Gestion tooltip
      const tooltips = document.querySelectorAll(
        `${SELECTOR_TOOLTIP}:not([${ATTR_TOOLTIP_STOP}])`
      );

      if (tooltips.length) {
        tooltips.forEach((el) => {
          el.setAttribute(ATTR_TOOLTIP_STOP, "");
          setTimeout(() => {
            el.removeAttribute(ATTR_TOOLTIP_STOP);
          }, 1000);
        });
      }
    }
  }

  if (!customElements.get("scroll-to-element")) {
    customElements.define("scroll-to-element", ScrollToElement);
  }
}();
